import React, {createContext, useContext, useMemo, useState} from 'react';

type SectionSidebarContextValue = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
};

const noop = () => {};

const defaultValue: SectionSidebarContextValue = {
  isOpen: true,
  open: noop,
  close: noop,
  toggle: noop,
};

const SectionSidebarContext = createContext<SectionSidebarContextValue | undefined>(undefined);

type SectionSidebarProviderProps = {
  children: React.ReactNode;
};

export function SectionSidebarProvider({children}: SectionSidebarProviderProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(true);

  const value = useMemo<SectionSidebarContextValue>(
    () => ({
      isOpen,
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
      toggle: () => setIsOpen((prev) => !prev),
    }),
    [isOpen],
  );

  return <SectionSidebarContext.Provider value={value}>{children}</SectionSidebarContext.Provider>;
}

type UseSectionSidebarReturn = SectionSidebarContextValue;

export function useSectionSidebar(): UseSectionSidebarReturn {
  const context = useContext(SectionSidebarContext);

  if (!context) {
    return defaultValue;
  }

  return context;
}

